import api from './api';
import { backgroundRequest } from './sessionActivity';

export const getAssetImportTemplate = () =>
  api.get('/v1/asset-import/template', { responseType: 'blob' });

export const validateAssetImport = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/v1/asset-import/validate', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const executeAssetImport = (importId, fileName, totalRows) =>
  api.post('/v1/asset-import/execute', { importId, fileName, totalRows });

// Durum yoklaması ARKA PLAN isteğidir: açık bırakılan içe aktarma ekranı oturumu canlı tutmasın.
export const getAssetImportStatus = (importId) =>
  api.get(`/v1/asset-import/status/${importId}`, backgroundRequest());

export const getAssetImportHistory = (params) =>
  api.get('/v1/asset-import/history', { params });
